import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, RouterStateSnapshot } from '@angular/router';
import { CardsService } from '@core/services/cards.service';
import { CardPageTypes } from '@core/typings/permission.typing';

export const permissionsGuard: CanActivateChildFn = async (
  activatedRouteSnapshot: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  if (!!activatedRouteSnapshot.component) {
    const CardService = inject(CardsService);
    
    return CardService.canAccessRoute(
      activatedRouteSnapshot.data.pageType as CardPageTypes,
      state.url
    )
  }

  return true;
};

